import { Directive, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[agInteract]',
})
export class AgInteractDirective {
  @Output() agInteract = new EventEmitter<Event>();

  @HostListener('click', ['$event'])
  handleClick(event: Event) {
    this.agInteract.emit(event);
  }

  @HostListener('keyup.enter', ['$event'])
  handleEnter(event: Event) {
    this.agInteract.emit(event);
  }

  @HostListener('keyup.space', ['$event'])
  handleSpace(event: Event) {
    event.preventDefault();
    this.agInteract.emit(event);
  }
}
